import React, { useState, useEffect } from 'react'
import { Box, SwxTheme, Password } from 'swx-atomic-component-lib'
import PasswordIcon from 'calcite-ui-icons-react/LockIcon'
import ViewMixedIcon from 'calcite-ui-icons-react/ViewMixedIcon'
import _ from 'lodash'
import i18n from '../../../../i18n'
import PasswordStrengthMeter from '../../../profile/PasswordStrengthMeter'

import {
  commonTextFieldWrapperStyle,
  iconRowStyle,
  iconStyle
} from '../style'

import {
  formPasswordRowStyle,
  formPasswordAgainRowStyle,
  containerPasswordStyle,
  strengthMeterStyle,
  meterHolderStyle,
  inputStyle,
  formPasswordColumn,
  fullWidth,
  halfWidth
} from './style'

function PasswordFormComponent (props) {
  const [passwordAgainError, setPasswordAgainError] = useState(false)
  const [passwordScore, setPasswordScore] = useState(1)
  const [passwordZxcvbnResult, setPasswordZxcvbnResult] = useState(null)

  const passwordDebounced = _.debounce(onPasswordChange, 275)
  const passwordAgainDebounced = _.debounce(onPasswordAgainChange, 275)

  const { passwordChange, passwordValue, passwordAgainValue, passwordAgainChange, arrangeInput = 'row', minScore, customIconStyle, disabled = false, customInputStyle = '' } = props

  // This is for reset
  useEffect(() => {
    if (passwordAgainValue !== '' && passwordValue !== passwordAgainValue) {
      setPasswordAgainError(true)
      passwordAgainChange(passwordAgainValue, true, passwordScore < minScore)
    } else if (passwordAgainValue !== '' && passwordValue === passwordAgainValue) {
      setPasswordAgainError(false)
      passwordAgainChange(passwordAgainValue, false, passwordScore < minScore)
    }
  }, [passwordValue])

  function onPasswordChange (value) {
    const { password, score, zxcvbnResult, isValid } = value
    setPasswordScore(score)
    setPasswordZxcvbnResult(zxcvbnResult)
    passwordChange(password, !isValid)
  }

  function onPasswordAgainChange (value) {
    const { password: passwordAgain } = value
    const passwordConfirmed = passwordValue !== '' && passwordAgain === passwordValue
    setPasswordAgainError(!passwordConfirmed)
    passwordAgainChange(passwordAgain, !passwordConfirmed)
  }

  return (
    <Box>
      <Box display='flex' flexDirection={arrangeInput} className='mobile-stacked col-s-6'>
        <Box customStyle={arrangeInput === 'row' ? formPasswordRowStyle : formPasswordColumn} className='col-s-6 mobile-input-margin'>
          <Box customStyle={iconRowStyle} className='mobile-hide'>
            <PasswordIcon size={16} color={SwxTheme.palette.primary} style={customIconStyle || iconStyle} className='mobile-hide' />
          </Box>
          <Box customStyle={commonTextFieldWrapperStyle} ml={3}>
            <Password
              id='sign-up-password'
              hasIcon={false}
              onChange={passwordDebounced}
              placeholder={i18n.registerNewPage.placeholder.password}
              customVisibleIcon={ViewMixedIcon}
              containerProps={containerPasswordStyle(passwordScore, passwordValue, minScore)}
              strengthCheck
              color='primary'
              customIconColor='g500'
              customStyle={`${inputStyle} ${customInputStyle}`}
              fakePlaceholder={false}
              tabIndex='5'
              disabled={disabled}
              noToggle={disabled}
              minScore={minScore}
            />
          </Box>
        </Box>
        <Box customStyle={arrangeInput === 'row' ? formPasswordAgainRowStyle : formPasswordColumn} className='col-s-6 mobile-input-margin'>
          <Box position='relative' w={29} h={16} mr={arrangeInput === 'row' ? 10 : 16} customStyle={iconRowStyle} className='mobile-hide' />
          <Box customStyle={commonTextFieldWrapperStyle} ml={3}>
            <Password
              id='sign-up-password-again'
              hasIcon={false}
              onChange={passwordAgainDebounced}
              placeholder={i18n.registerNewPage.placeholder.confirmPassword}
              customVisibleIcon={ViewMixedIcon}
              containerProps={containerPasswordStyle(5, passwordValue)}
              defaultValue={passwordAgainValue}
              error={passwordAgainError}
              message={passwordAgainError ? i18n.registerNewPage.error.confirmPassword : ''}
              color='primary'
              customIconColor='g500'
              customStyle={`${inputStyle} ${customInputStyle}`}
              fakePlaceholder={false}
              disabled={disabled}
              noToggle={disabled}
              tabIndex='5'
            />
          </Box>
        </Box>
      </Box>
      <PasswordStrengthMeter
        password={passwordValue}
        score={passwordScore}
        zxcvbnResult={passwordZxcvbnResult}
        meterHolderStyle={meterHolderStyle}
        strengthMeterStyle={arrangeInput === 'row' ? strengthMeterStyle.concat(halfWidth) : strengthMeterStyle.concat(fullWidth)}
        minScore={minScore}
      />
    </Box>
  )
}

export default PasswordFormComponent
